import {
  headerLayout as headerLayoutIcon,
  footerLayout as footerLayoutIcon,
  notFoundLayout as notFoundLayoutIcon,
} from "../Icons";

const availableLayouts = [
    {
        'key': 'header',
        'image': headerLayoutIcon,
        'desc': "Design custom WordPress headers, beyond theme customizer settings."
    },
    {
        'key': 'footer',
        'image': footerLayoutIcon,
        'desc': "Design custom WordPress footers, beyond theme customizer settings."
    },
    {
        'key': '404-page',
        'image': notFoundLayoutIcon,
        'desc': "Build & customize 404 pages to match your site's style.",
    },
];

export default availableLayouts;